'use client';
import BaseModal from '@c/modals/BaseModal';
import Button from '@ui/Button';

import { JobOpening } from './jobs';

interface JobModalProps {
  job: JobOpening | null;
  isOpen: boolean;
  dismiss: () => void;
}

const sectionHeadingCss =
  'text-[2.25rem] font-bold tracking-[-0.01em] text-brand-black';
const bodyCss = 'text-[1.75rem] font-medium leading-[1.5] text-text-muted';

const JobModal = ({ job, isOpen, dismiss }: JobModalProps) => {
  const applyHref = job
    ? `mailto:${job.applyEmail}?subject=${encodeURIComponent(
        `Application: ${job.title}`
      )}`
    : '';

  return (
    <BaseModal isOpen={isOpen} dismiss={dismiss} title="We are hiring!">
      {job && (
        <div className="flex max-h-[70vh] w-[90rem] max-w-[calc(100vw-3.2rem)] flex-col gap-[3rem] overflow-y-auto px-[3.2rem] pb-[4rem] pt-[3rem]">
          <h2 className="text-[3rem] font-bold tracking-[-0.01em] text-brand-secondary">
            {job.title}
          </h2>

          <div className="flex flex-col gap-[1.6rem]">
            <h3 className={sectionHeadingCss}>Job Description</h3>
            {job.description.map((paragraph) => (
              <p key={paragraph} className={bodyCss}>
                {paragraph}
              </p>
            ))}
          </div>

          <div className="flex flex-col gap-[1.6rem]">
            <h3 className={sectionHeadingCss}>Skills &amp; Requirements</h3>
            <ul className="flex flex-col gap-[0.8rem]">
              {job.skills.map((skill) => (
                <li
                  key={skill}
                  className={`flex items-start gap-[1.2rem] ${bodyCss}`}
                >
                  <span className="mt-[0.9rem] h-[0.6rem] w-[0.6rem] shrink-0 rounded-full bg-text-muted" />
                  <span>{skill}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-[1.6rem]">
            <h3 className={sectionHeadingCss}>Interested in this role?</h3>
            <p className={bodyCss}>
              Send your resume and a brief introduction to{' '}
              <a
                href={applyHref}
                className="font-bold text-brand-secondary hover:underline"
              >
                {job.applyEmail}
              </a>
              , or click below to apply.
            </p>
          </div>

          <div className="flex justify-center pt-[1rem]">
            <Button
              type="secondary"
              text="Apply"
              href={job.applyUrl}
              target="_blank"
              height="normal"
              className="h-[6rem] w-full max-w-[40rem] justify-center text-[2rem]"
            />
          </div>
        </div>
      )}
    </BaseModal>
  );
};

export default JobModal;
